var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000152588,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#5E7CE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18.5254V5.47467C19.0003 4.66015 18.2166 3.99973 17.25 4.00002H6.75C5.7834 3.99973 4.99966 4.66015 5 5.47467V18.5254C4.99966 19.3399 5.7834 20.0003 6.75 20H17.25C18.2166 20.0003 19.0003 19.3399 19 18.5254ZM14.1213 14.8787C14.6839 15.4413 15 16.2044 15 17H9C9 16.2044 9.31607 15.4413 9.87868 14.8787C10.4413 14.3161 11.2044 14 12 14C12.7956 14 13.5587 14.3161 14.1213 14.8787ZM11.9952 9.00002C13.1004 8.9974 13.9981 9.89159 14 10.9967C14.0017 12.1019 13.1067 12.9991 12.0016 13C10.8964 13.0008 10 12.1051 10 10.9999C9.99888 9.89684 10.8919 9.00152 11.9952 9.00002ZM10.4 7.36781H13.6C13.8209 7.36781 14 7.14379 14 6.86781C14 6.59164 13.8209 6.36781 13.6 6.36781H10.4C10.1792 6.36781 10 6.59164 10 6.86781C10 7.14379 10.1792 7.36781 10.4 7.36781Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.35dc247aee2b4ffab29e17f1953e136c.svg";
export { ForwardRef as ReactComponent };